export const transparentize = (colour: string, opacity: number) => {
  const formattedColour =
    colour.slice(0, 2) == '--' ? `var(${colour})` : colour;

  return `color-mix(in srgb, ${formattedColour} ${opacity}%, transparent)`;
};
